
import CardRh from "@/components/cards/ManzaCard.vue"
import DisciplinaService from "@/service/v1/sigap/DisciplinaService"
import { Options, Vue } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue"
import Editar from "./_Editar.vue" 
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { namespace } from 'vuex-class';
const authStore = namespace('auth');  


@Options({
    name: "DisciplinaShow",
    components: { CardRh, KDataTable, Editar   },
})
export default class DisciplinaShow extends Vue {

    @authStore.Getter
    public perfis!: any

    @authStore.Getter
    public token!: any

    public service = new DisciplinaService(); 
    public model: any = null;
    public identificador: any = 1;
    public model_update: any = null;
    public processando = false;
    public modal_atualizar = 'modal_visualizar_disciplina_update_showing';
    

    get hasPermissao( ): boolean {
        return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
    }

    get hasPermissaoEditar( ): boolean {
        return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
    }

    
    get hasAdmin( ): boolean {
        return SiteUtils.hasPermissao( [ PerfilConfig.Admin  ] ,  this.perfis); 
    }

    created() {
        this.buscaDisciplina();
    }
  

    public buscaDisciplina() {
        this.processando = true;
        this.service.getModel(this.$route.params.id)
            .then(response => {
                this.model = JSON.parse(JSON.stringify(response));
                this.model_update =  this.model;
                this.identificador++;
                this.processando = false;
            })
            .catch(error => {
                this.processando = false;
            });
    }

    public setModelUpdate() {
        this.model_update = null;
        setTimeout(() => {
            this.model_update = this.model;
        }, 10);
    }
 
} 
